<template lang="pug">
    div(class="px-6 pt-4 pb-2 text-dark lg:text-gray-light lg:py-10 lg:px-3")
        div(class="lg:container lg:flex lg:gap-x-16")
            div(class="text-center mb-6 lg:mb-0 lg:text-left")
                div(
                    v-if="$device.isDesktop"
                    class="space-y-6"
                    :class="[ $config.runtime.theme.footer.navigation.subscribePosition === 'LEFT' ? 'max-w-[300px]' : 'max-w-[225px]' ]"
                )
                    nuxt-link(
                        class="block"
                        :to="{ name: 'home' }"
                    )
                        Logo(
                            class="w-full h-full"
                            isLazy
                            isLight
                        )

                    SocialMedia

                    div(
                        v-if="$config.runtime.theme.newsletter.enabled && $config.runtime.theme.footer.navigation.subscribePosition === 'LEFT'"
                        class="pt-2"
                    )
                        p(class="font-bold text-lg mb-3") GET ON THE LIST
                        p(
                            class="text-xs mb-4"
                            v-html="$config.runtime.theme.footer.navigation.subscribeText"
                        )
                        Subscribe(formName="footer-email-subscribe")

                img(
                    v-if="$accessibility.enabled"
                    @click="$accessibility.open"
                    src="~/assets/accessibility-icon.svg"
                    alt="Open the Accessibility Interface (Can also be opened using the Alt+9 Key)"
                    class="inline-block w-16 h-8 cursor-pointer mt-2 lg:mt-6"
                    loading="lazy"
                )

            div(class="lg:flex-1 lg:flex lg:justify-center lg:gap-x-20")
                template(v-for="group in $config.runtime.theme.footer.navigation.groups")
                    NavigationGroup(
                        :title="group.title"
                        :links="group.links"
                        :class="{ 'lg:flex-1': !$config.runtime.theme.newsletter.enabled }"
                    )

            NavigationGroup(
                v-if="$config.runtime.theme.newsletter.enabled && $config.runtime.theme.footer.navigation.subscribePosition === 'RIGHT' && $device.isDesktop"
                title="Get on the List"
                class="w-1/4"
            )
                p(
                    class="text-xs mb-4"
                    v-html="$config.runtime.theme.footer.navigation.subscribeText"
                )
                Subscribe(formName="footer-email-subscribe")

</template>

<script>
import FlexLink from '@/components/flexLink'
import Logo from '@/components/logo'
import Subscribe from '@/components/subscribe/'
import NavigationGroup from './navigationGroup'
import SocialMedia from './socialMedia'

export default {
    name: 'Navigation',
    components: {
        FlexLink,
        Logo,
        NavigationGroup,
        SocialMedia,
        Subscribe,
    },
}
</script>
